var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnProfileCameraWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5C8.645 7.5 7.5 8.645 7.5 10C7.5 11.355 8.645 12.5 10 12.5C11.355 12.5 12.5 11.355 12.5 10C12.5 8.645 11.355 7.5 10 7.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 4.16675H14.5115L12.2557 1.91091C12.0994 1.75462 11.8875 1.6668 11.6665 1.66675H8.33317C8.11217 1.6668 7.90025 1.75462 7.744 1.91091L5.48817 4.16675H3.33317C2.414 4.16675 1.6665 4.91425 1.6665 5.83341V15.0001C1.6665 15.9192 2.414 16.6667 3.33317 16.6667H16.6665C17.5857 16.6667 18.3332 15.9192 18.3332 15.0001V5.83341C18.3332 4.91425 17.5857 4.16675 16.6665 4.16675ZM9.99984 14.1667C7.7415 14.1667 5.83317 12.2584 5.83317 10.0001C5.83317 7.74175 7.7415 5.83341 9.99984 5.83341C12.2582 5.83341 14.1665 7.74175 14.1665 10.0001C14.1665 12.2584 12.2582 14.1667 9.99984 14.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnProfileCameraWhite);
export default __webpack_public_path__ + "static/media/icn_profile_camera_white.ed9ef0a5c379ecad6bbf5e3e75d7c9c5.svg";
export { ForwardRef as ReactComponent };